import { Plus, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

// Linhas de TPA no formulário de nova conta bancária
export const TPAFormRows = ({ tpas, onChange }) => {
  const update = (i, patch) => onChange(tpas.map((t, idx) => (idx === i ? { ...t, ...patch } : t)));
  return (
    <div className="space-y-2 rounded-lg border p-3" data-testid="tpa-form-rows">
      <div className="flex items-center justify-between">
        <Label className="text-xs font-semibold uppercase tracking-wide">TPA (terminais Multicaixa) desta conta</Label>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => onChange([...tpas, { name: "", serial: "" }])} data-testid="tpa-add-row-btn">
          <Plus className="w-3 h-3 mr-1" /> TPA
        </Button>
      </div>
      <p className="text-[11px] text-muted-foreground">Dê um nome a cada terminal (ex.: "TPA Comida", "TPA Bebidas") para diferenciar as vendas com cartão.</p>
      {tpas.map((t, i) => (
        <div key={i} className="grid grid-cols-[1fr_120px_32px] gap-2 items-center" data-testid={`tpa-row-${i}`}>
          <Input value={t.name} placeholder="Nome do TPA *" onChange={(e) => update(i, { name: e.target.value })} data-testid={`tpa-name-${i}`} />
          <Input value={t.serial} placeholder="Nº série / ID" onChange={(e) => update(i, { serial: e.target.value })} data-testid={`tpa-serial-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="h-8 w-8 text-destructive" onClick={() => onChange(tpas.filter((_, idx) => idx !== i))} data-testid={`tpa-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
        </div>
      ))}
      {tpas.length === 0 && <p className="text-xs text-muted-foreground">Sem TPA — pode adicionar depois no cartão da conta.</p>}
    </div>
  );
};
